import React from 'react';

/**
 * The title and the line under it at the top of each tab — "فصول الكتاب",
 * "سجل الاختبارات", "أداؤك وتقدّمك", "الموارد التعليمية".
 *
 * 20px bold in slate/700, 8px, then 14px in slate/400. An `h2`: the course's
 * name in the hero above is the page's one `h1`.
 */
const TabHeading = ({ id, title, lead, className = '' }) => (
    <div className={`tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-gap-[8px] tw-text-start ${className}`}>
        <h2 id={id} className="tw-m-0 tw-text-[20px] tw-font-bold tw-leading-[1.5] tw-text-v2-student-name">
            {title}
        </h2>
        <p className="tw-m-0 tw-text-[14px] tw-leading-[1.6] tw-text-v2-student-nav">
            {lead}
        </p>
    </div>
);

export default TabHeading;
